<template>
  <div class="d-flex w-100 justify-space-between">
    <div class="w-100 d-flex align-center overflow-ellipsis">
      <input
        :value="params.layout._id"
        name="selected"
        type="radio"
        @input="params.selectLayoutFunction(params.layout._id)"
      />
      <span class="layout-name">{{ params.layout.name }}</span>
    </div>
    <div v-if="isDeleteVisible">
      <v-icon
        role="img"
        aria-hidden="false"
        icon="rtls:BaseIconTrash"
        color="primary"
        size="24"
        @click="params.onDeleteLayout(params.layout)"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useContextStore } from '@/stores/context';
import { get } from 'lodash';

const props = defineProps({ params: Object });
const contextStore = useContextStore();
const isDeleteVisible = computed(() => {
  return get(props.params, 'layout.createdBy._id', '') === contextStore.currentUserProfile._id;
});
</script>

<style lang="scss" scoped>
.layout-name {
  text-decoration: underline;
  font-size: 12px !important;
  padding-left: 10px;
  text-transform: capitalize;
}
</style>
